const coverTypes = {
  natuurlijke_dekking: "Natuurlijke dekking",
  kunstmatige_inseminatie: "Kunstmatige inseminatie",
};

export default coverTypes;
